import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { BREAKPOINT_MEDIUM_PX } from '@/settings';
@customElement('fg-accordion-divider')
export class FgAccordionDivider extends LitElement {
  render() {
    return html`
      <hr />
    `;
  }

  static styles = [
    css`
      hr {
        background-image: linear-gradient(
          to right,
          var(--fg-gray--300, var(--fg-fallback-gray--300)) 5px,
          white 5px
        );
        background-position: 0 bottom;
        background-repeat: repeat-x;
        background-size: 8px 1px;
        border: none;
        display: block;
        height: 1px;
        margin: 16px -16px;
      }
      @media screen and (max-width: ${BREAKPOINT_MEDIUM_PX - 1}px) {
        hr {
          margin: 12px -12px;
        }
      }
    `,
  ];
}
